/*
 * errorGroups  mock data
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { randomItem, randomNumber, randomString, times } from "../mockHelpers";
import { DOC_ERROR_SEVERITY } from "@adapptio/lib-blueprint";
import { IErrorListGroup } from "../../../../ui/components/ErrorList/ErrorListTypes";

const randomSeverity = () =>
	randomItem([
		DOC_ERROR_SEVERITY.WARNING,
		DOC_ERROR_SEVERITY.ERROR,
		DOC_ERROR_SEVERITY.INFO,
		DOC_ERROR_SEVERITY.HINT
	]);

export const getErrorGroups = (): IErrorListGroup[] =>
	times<IErrorListGroup>(
		() => ({
			documentUri: randomItem([ null, randomString(6, 16) ]),
			parseErrors: times<IErrorListGroup["parseErrors"][number]>(
				() => ({
					severity: randomSeverity(),
					name: "PARSEError",
					message: times(randomString, randomNumber(3, 12), 0, 18).join(" "),
					range: {
						start: {
							col: randomNumber(0, 120),
							line: randomNumber(0, 120)
						},
						end: {
							col: randomNumber(0, 120),
							line: randomNumber(0, 120)
						}
					}
				}),
				randomNumber(0, 4)
			),
			runtimeErrors: times<IErrorListGroup["runtimeErrors"][number]>(
				() => ({
					severity: randomSeverity(),
					name: "RUNTIMEError",
					message: times(randomString, randomNumber(3, 12), 0, 18).join(" "),
					modelNodeId: randomNumber(2500, 3424245),
					modelPath: times(randomString, 12, 1, 12),
					details: randomItem([ null, times(randomString, randomNumber(1, 3), 5, 12) ])
				}),
				randomNumber(0, 4)
			),
			compileErrors: times<IErrorListGroup["compileErrors"][number]>(
				() => ({
					severity: randomSeverity(),
					name: "COMPILEError",
					message: times(randomString, randomNumber(3, 12), 0, 18).join(" "),
					modelNodeId: randomNumber(2500, 3424245),
					modelPath: times(randomString, 12, 1, 12),
					details: randomItem([ null, times(randomString, randomNumber(1, 3), 5, 12) ])
				}),
				randomNumber(0, 4)
			)
		}),
		8
	);
